import { DynamicStandaloneSoMe, DynamicStandaloneSoMeProps } from '@/components/SoMe';
import { componentTheme } from '@/styles/Footer';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type FooterSoMeProps = DynamicStandaloneSoMeProps;

export const FooterSoMeComponent: StandaloneComponent<FooterSoMeProps> = (props) => {
  return (
    <DynamicStandaloneSoMe
      {...mergeProps(
        {
          options: {
            theme: componentTheme('soMe'),
          },
        },
        props
      )}
    />
  );
};
